import './App.css';
import { BrowserRouter, Route, Routes} from 'react-router-dom'
import React from 'react'

const SignUp = React.lazy(() => import('./views/MemberSignUp'));
const ThankYou = React.lazy(() => import('./views/MemberSignUpMessage'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route exact path="/signup" name="SignUp Page" element={<SignUp />} />
          <Route exact path="/thankYou" name="thankYou" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
